<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="tab-view setting-layout">
    <div class="tab-header">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['tab-button', { active: activeTab === index }]"
        @click="setActiveTab(index)"
        :aria-selected="activeTab === index"
        :aria-controls="`tab-panel-${index}`"
        :id="`tab-button-${index}`"
        role="tab"
      >
        {{ tab.header }}
      </button>
    </div>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      registerTab: this.registerTab,
      activeTab: () => this.activeTab,
    };
  },
  data() {
    return {
      tabs: [],
      activeTab: 0,
    };
  },
  methods: {
    registerTab(tab) {
      this.tabs.push(tab);
      return this.tabs.length - 1; 
    },
    setActiveTab(index) {
      this.activeTab = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-view {
  font-family: "voyado Text";
  color: #21211f;
}

.tab-header {
  display: flex;
  border-bottom: 1px solid #c0c0bc;
  gap: 20px; /* Spacing between tabs */
  padding-left: 20px; /* Added padding to the left of the first tab */
}

.tab-button {
  padding: 11px 0px 7px 0px;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent; 
  cursor: pointer;
  color: #21211f;
  text-align: center;
  font-family: 'Voyado Text';
  // transition: border-bottom 0.3s ease; /* Smooth transition for active state */

  &.active {
    border-bottom: 3px solid #791a3f; /* Maroon color matching the image */
    color: #000000;
  }
  &:hover{
    color: #6c757d;
  }
  &.active:hover{
    color: #000000;
  }


  &:focus {
    outline: none;
    border-bottom: 3px solid #791a3f;
  }
}

.tab-content {
  padding: 22px 20px 20px 20px;
  border-top: none;
}
</style>